"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moderationAction = exports.moderationStatus = exports.feedType = void 0;
var feedType;
exports.feedType = feedType;

(function (feedType) {
  feedType["GROUP"] = "group";
})(feedType || (exports.feedType = feedType = {}));

var moderationStatus;
exports.moderationStatus = moderationStatus;

(function (moderationStatus) {
  moderationStatus["PENDING"] = "pending";
  moderationStatus["APPROVED"] = "approved";
  moderationStatus["DELETED"] = "deleted";
})(moderationStatus || (exports.moderationStatus = moderationStatus = {}));

var moderationAction;
exports.moderationAction = moderationAction;

(function (moderationAction) {
  moderationAction["APPROVE"] = "approve";
  moderationAction["DELETE"] = "delete";
})(moderationAction || (exports.moderationAction = moderationAction = {}));
//# sourceMappingURL=types.js.map